import styled from "styled-components";
import { NavLink } from "react-router-dom";

export const HeaderContainer = styled.div`
  /* background-color: #ff8b8b; */
  margin: 0 clamp(1px, 5vw, 100px);
  padding: 20px 0;
  /* padding: 0 15px; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 25px;
    margin: 0 clamp(1px, 2vw, 100px);
  }
`;

export const Logo = styled.div`
  font-size: clamp(18px, 3vw, 42px);
  font-weight: bold;
  font-family: ${(props) => props.lang === "en" ? "Purisa, sans-serif" : "Tanha, sans-serif"};
  img {
    width: 25px;
    height: 25px;
    opacity: 1;
    margin: 0 8px;
    margin-bottom: -4px;
  }
  @media (max-width: 768px) {
    a {
      display: flex;
      flex-direction: row-reverse;
      // align-items: center:
    }
  }
`;


export const Icon = styled.div`
  display: none;
  .bar1,
  .bar2,
  .bar3 {
    width: 20px;
    height: 1px;
    background-color: #333;
    margin: 6px 0;
    transition: 0.4s;
  }
  /* background-color: red; */
  &.change .bar1 {
    transform: translate(0, 7px) rotate(-45deg);
  }

  &.change .bar2 {
    opacity: 0;
  }

  &.change .bar3 {
    transform: translate(0, -7px) rotate(45deg);
  }

  @media (max-width: 768px) {
    display: block;
    cursor: pointer;
    }
    `;

export const Wrapper = styled.div`
  padding: 0;
  margin: 0;
  display: flex;
  // flex-direction: row;
  // background-color:red;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 768px) {
    width: 100%;
  }
`

export const Nav = styled.nav`
  display: flex;
  align-items: center;
  position: relative;

  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
    display: ${(props) => (props.isopen ? "flex" : "none")};
  }
`;

export const NavItem = styled.div`
  position: relative;
  margin: 0 .8vw;
  cursor: pointer;
  // font-family: ${(props) => props.lang === "en" ? "Purisa, sans-serif" : "Tanha, sans-serif"};
  font-size: clamp(4px, 1.2em, 32px);

  /* color: ${(props) => props.theme.colors.txt.color1}; */
  &:hover {
    color: ${(props) => props.theme.colors.txt.color4};
  }
  @media (max-width: 768px) {
    border-bottom: 1px solid #e9e9e9;
    margin: 6px 0;
    width: 100%;
    text-align: ${(props) => props.lang === "en" ? "left" : "right"};

  }
`;

export const MenuLink = styled(NavLink)`
  color: ${(props) => props.theme.colors.txt.color1};
  text-decoration: none;
  /* text-transform: uppercase; */
  /* padding: 10px; */
  &:hover {
    /* font-weight: 900; */
    color: ${(props) => props.theme.colors.txt.color4} !important;
    transform: scale(1.05);
    transition: transform 0.1s, color 0.1s;
  }
  
  &.active {
    font-weight: 900;
    color: ${(props) => props.theme.colors.txt.color4};
    }
    
    span {
      margin: 0 6px;
      // background-color: red;
  }
`;

export const Submenu = styled.div`
  display: ${(props) => (props.isopen ? "block" : "none")};
  background-color: ${(props) => props.theme.colors.bg.color0};
  padding: 10px 0;
  margin-top: 5px;
  border-radius: 4px;
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2); */
  position: absolute;
  left: ${(props) => props.lang === "en" && "0"};;
  right: ${(props) => props.lang === "fa" && "0"};;
  z-index: 1;
  min-width: 280px;
  // font-size: ${(props) => props.lang === "en" ? "18px" : "28px"};

  @media (max-width: 768px) {
    position: static;
    width: 100%;
    box-shadow: none;
  }
`;

export const SubmenuItem = styled.div`
  padding: 8px 12px;
  cursor: pointer;
  
  /* color: ${(props) => props.theme.colors.txt.color5} !important; */

  &:hover {
    /* font-weight: 700; */
    background-color: #ffffff;
    /* border-radius: 5px; */
  }
`;


export const SubmenuImage = styled.img`
  width: 18px;
  height: 18px;
  opacity: 0.7;
  // margin-right: 8px;
  margin-bottom: -4px;
`;
